import React from "react";
import commonstyles from "../../../styles/Management_Common.module.css";
import styles from "../../../styles/FetchUser.module.css";
import Search from "../../../assets/images/search_icon.svg";
import { useEffect, useState, useRef } from "react";
import { AxiosInstance, PORTS } from "../../../utils/apiService";
import Plus from "../../../assets/images/plus_white_icon.svg";
import BlackLeftArrow from "../../../assets/images/black_left_arrow.svg";
import { useHistory } from "react-router-dom";
import adminProductEdit from "../../../assets/images/admin_product_edit_icon.svg";
import adminProductDelete from "../../../assets/images/admin_delete.svg";
import AddUser from "./AddUser";
import EditUserComponent from "./EditUser";
import Pagination from "../../modules/ReusableComponent/Pagination";
import LoadingIndicator from "../../modules/ReusableComponent/LoadingIndicator";
import { Link } from "react-router-dom";
import SearchComponent from "../SearchManagement/SearchComponent";
import AntTableComponent from "../../modules/ReusableComponent/AntTableComponent";
import ConfirmationBox from "../../modules/ReusableComponent/ConfirmationBox";
import { arrayMove } from "react-movable";
import {
  Dropdown,
  Menu,
  message as massages,
  Select,
  notification,
  Tooltip,
} from "antd";
import ButtonComponent from "../../modules/ReusableComponent/ButtonComponent";
import MovableListComponent from "../../modules/ReusableComponent/MovableListComponent";
import dots from "../../../assets/images/column_dots.svg";
import arrowDown from "../../../assets/images/arrow_down.svg";
import AntDateRangeSelectComponent from "../../modules/ReusableComponent/AntDateRangeSelectComponent";
import moment from "moment";
import RoleManagement from "../UserManagement/RoleManagement";
import ImagePreviewChip from "../../modules/ProductManagement/ImagePreviewChip";
import customerProfile from "../../../assets/images/customer_profile.svg";
import excelIcon from "../../../assets/images/excel_icon.svg";
import exportIcon from "../../../assets/images/export_icon.svg";
import { clone, upperCase, upperFirst } from "lodash";
import * as XLSX from "xlsx";
import pdf_icon from "../../../assets/images/pdf_icon.svg";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import {
  AllModules_,
  buttons,
  treeData_,
} from "../../modules/ReusableComponent/PermissionObject";

const pageSizes = [10, 20, 50];
const defaultPageSize = 10;

const originalHeaders = [
  { _id: 1, status: 1, name: "Select", value: "select" },
  { _id: 3, status: 1, name: "Avatar", value: "avatar" },
  { _id: 2, status: 1, name: "Name", value: "name" },
  { _id: 4, status: 1, name: "Email Address", value: "email_address" },
  { _id: 5, status: 1, name: "Roles", value: "roles" },
  { _id: 6, status: 1, name: "Access", value: "access" },
  { _id: 7, status: 1, name: "Action", value: "action" },
];

const filters = [
  // { id: 1, isChecked: false, name: "Region", value: "region" },
  // { id: 2, isChecked: false, name: "Status", value: "status" },
  { id: 3, isChecked: false, name: "Date", value: "date" },
];
const daysObj = [
  { _id: 1, name: "Today", value: 1 },
  { _id: 7, name: "This Week", value: 2 },
  { _id: 2, name: "Last 7 Days", value: 7 },
  { _id: 3, name: "Last 30 Days", value: 30 },
  { _id: 4, name: "Last 70 Days", value: 70 },
  { _id: 5, name: "Last 90 Days", value: 90 },
  { _id: 6, name: "Last 12 Months", value: 365 },
  { _id: 8, name: "Custom", value: "custom" },
];
const bulkAction = [
  { _id: 2, isChecked: true, name: "Enable", value: 1 },
  { _id: 3, isChecked: false, name: "Disable", value: 2 },
];

const status_filter = [
  { _id: 1, name: "Active", value: 1 },
  { _id: 0, name: "Deactive", value: 0 },
];

let date = new Date();
let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
const placeholder = [
  moment(firstDay).format("DD-MM-YYYY"),
  moment(lastDay).format("DD-MM-YYYY"),
];
const dateFormatList = ["DD-MM-YYYY", "DD-MM-YYYY"];

function UserManagement() {
  const accessregion = localStorage.getItem('accessregion');
  let permissionsArr = JSON.parse(localStorage.getItem("permissions")) || [];

  const history = useHistory();
  const [customerList, setCustomerList] = useState([]);
  const [search, setSearch] = useState("");
  const [nextPage, setNextPage] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [pagination, setPagination] = useState({});
  const [selectedCustomer, setSelectedCustomer] = useState({});
  const [childComponentVisibility, setChildComponentVisibility] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [IsLoading, setIsLoading] = useState({ delete: false, list: true });
  const [headers, setHeaders] = useState(originalHeaders);
  const [items, setItems] = useState(originalHeaders);
  const [selectFilter, setSelectFilter] = useState(filters);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [regionId, setRegionId] = useState("");
  const [regionName, setRegionName] = useState("All Region");
  const [regions, setRegions] = useState([]);
  const [visible, setVisible] = useState(false);
  const [statusId, setStatusId] = useState("");
  const [status, setStatus] = useState(status_filter);
  const [bulkActionFilter, setBulkActionFilter] = useState(bulkAction);
  const [filterDays, setFilterDays] = useState();
  const [filterDaysName, setFilterDaysName] = useState("Date");
  const pdfExportComponent = useRef(null);
  const [filterdayArr, setFilterdayArr] = useState(daysObj);
  const [sortorder, setSortorder] = useState(null);
  const [seletedUseId, setSeletedUseId] = useState("");
  const [isDeleteModule, setIsDeleteModule] = useState(false);
  const [filteredDate, setFilteredDate] = useState({
    startDate: "",
    endDate: "",
  });
  const [toggle, setToggle] = useState(true);

  const [filterOptionsGlobal,setFilterOptionsGlobal] = useState();

  const [columns, setColumns] = useState([
    {
      visible: false,
      key: "select",
      render: (text, record, index) => (
        <input
          style={{ cursor: "pointer" }}
          type="checkbox"
          checked={record.isChecked}
          className={`${commonstyles.childCheckbox}`}
          onChange={(e) => childCheckbox(e, record)}
        ></input>
      ),
    },
    {
      title: "Avatar",
      visible: false,
      key: "avatar",
      render: (text, record, index) => (
        <span>
          {record.profileImg ? (
            <img
              src={record.profileImg}
              className={commonstyles.avatar}
              alt=""
            />
          ) : (
            <img
              src={customerProfile}
              className={commonstyles.avatar}
              alt="profile_img"
            />
          )}
        </span>
      ),
      // sorter: true,
    },
    {
      title: "Name",
      visible: false,
      key: "name",
      render: (text, record, index) => <span>{upperFirst(record.name)}</span>,
      sorter: true,
    },
    {
      title: "Email Address",
      visible: false,
      key: "email_address",
      render: (text, record, index) => <span>{record.email}</span>,
    },
    {
      title: "Roles",
      visible: false,
      key: "roles",
      render: (text, record, index) => <span>{record?.role?upperFirst(record.role):"-"}</span>,
    },
    {
      title: "Access",
      visible: false,
      key: "access",
      render: (text, record, index) => (
        <span>{record?.roleType === 0 ? "Limited" : "Full"}</span>
      ),
    },
    {
      title: "Action",
      visible: false,
      key: "action",
      render: (text, record, index) => (
        <span>
          <Tooltip placement="topRight" title="Edit user">
            <img
              src={adminProductEdit}
              className={commonstyles.admin_table_edit_img}
              onClick={() => editCustomer(record)}
              alt="Edit action icon"
              // title="Edit user"
              style={{ cursor: "pointer" }}
            />
          </Tooltip>
          <Tooltip
              placement="topRight"
              title="Delete User"
            > <img
                src={adminProductDelete}
                className={commonstyles.admin_table_edit_img}
                onClick={() => deletedUser(record)}
                alt="Delete action icon"
                // title="Delete region"
                style={{ cursor: "pointer", padding:"0 10px" }}
              /></Tooltip>
        </span>
      ),
    },
  ]);

  useEffect(() => {
    set_new_header(headers);
    getRegionList();
    userList(pageSize, nextPage, "");
    localStorage.removeItem("selectedUsers");
    AllModules_.forEach((item) => {
      item.data.forEach((subItem) => {
        subItem.add = false;
        subItem.edit = false;
        subItem.view = false;
      });
    });
    if (history?.isRole) {
      setToggle(false);
    } else {
      setToggle(true);
    }
    if (!accessregion) {
      let checkDuplicates = filters.filter(item => item.name === 'Region')?.length > 0 ? true : false;
      if (!checkDuplicates) {
        filters.push({ id: 1, isChecked: false, name: "Region", value: "region" })
      }
    };
    return () => {
      localStorage.removeItem("customerList");
      localStorage.removeItem("selectedUsers");
    };
  }, []);


  function deletedUser(userDetail) {
    setSeletedUseId(userDetail._id);
    setIsDeleteModule(true);
  }

  function cancelDelete() {
    setSeletedUseId("");
    setIsDeleteModule(false);
  }

  const set_new_header = (response) => {
    var newArr = [];
    const data = response;
    for (let i = 0; i < data.length; i++) {
      const columnsClone = [...columns];
      let objIndex = columnsClone.findIndex((obj) => obj.key === data[i].value);
      if (columnsClone[objIndex] !== undefined) {
        columnsClone[objIndex].visible = data[i].status === 1 ? true : false;
        newArr.push(columnsClone[objIndex]);
      }
    }
    setColumns(newArr);
  };

  function getRegionList() {
    AxiosInstance(PORTS.REGION_SERVICE, "application/json")
      .get("/admin/region/getRegionList")
      .then((res) => {
        if (res.status === 200 && res.data.status === 200) {
          let obj = { name: "All Region", value: "", _id: "" };
          res.data?.daaata?.unshift(obj);
          setRegions(res.data.daaata);
        }
      })
      .catch((er) => {
        console.log(er);
      });
  }

  function searchHandler(e) {
    const { value } = e.target;

    setSearch(value);
    if (!value) {
      const updatedFilter = {
        search: "",
        nextpage: 1,
        filterDays:filterDays,
        sortOrder:sortorder,
        regionId:regionId
      };
      debounceSearch(updatedFilter);
    }
  }

  /**
   * @author Rajkumar
   * @param {pageSize, nextPage, filterarr, type}
   * To get filtered response after applying required filters
   */
  function userList(pageSize, nextPage, filterarr, type) {
    if(!type){
      setIsLoading({list:true});
    }
    const filterOptions = {
      pagesize: pageSize,
      nextpage: nextPage,
    };
    if (filterarr && filterarr.search) {
      filterOptions.search = filterarr.search;
    } else if (search !== "") {
      if (filterarr && filterarr.search !== "") {
        filterOptions.search = search;
      }
    }
    if (localStorage.getItem('accessregion')) {
      filterOptions.regionId = localStorage.getItem('accessregion');
    } else if (filterarr && filterarr.regionId) {
      filterOptions.regionId = filterarr.regionId;
    } else if (regionId !== "") {
      if (filterarr && filterarr.regionId !== "") {
        filterOptions.regionId = regionId;
      }
    }
    if (filterarr && filterarr.status) {
      filterOptions.status = Number(filterarr.status);
    } else if (statusId !== "") {
      if (filterarr && filterarr.status !== "") {
        filterOptions.status = Number(statusId);
      }
    }
    if (filterarr && filterarr.filterDays) {
      filterOptions.filterDays = Number(filterarr.filterDays);
    } else if (filteredDate.filterDays !== "") {
      if (filterarr && filterarr.filterDays !== "") {
        filterOptions.filterDays = Number(filterDays);
      }
    }
    if (filterarr && filterarr.startDate) {
      filterOptions.startDate = filterarr.startDate;
    } else if (filteredDate.startDate !== "") {
      if (filterarr && filterarr.startDate !== "") {
        filterOptions.startDate = filteredDate.startDate;
      }
    }
    if (filterarr && filterarr.endDate) {
      filterOptions.endDate = filterarr.endDate;
    } else if (filteredDate.endDate !== "") {
      if (filterarr && filterarr.endDate !== "") {
        filterOptions.endDate = filteredDate.endDate;
      }
    }
    if (filterarr && filterarr.sortOrder !== "") {
      filterOptions.sortOrder = Number(filterarr.sortOrder);
    } else if (filteredDate.sortOrder !== "") {
      if (filterarr && sortorder !== "") {
        filterOptions.sortOrder = Number(sortorder);
      }
    }
    if (filterOptions?.sortOrder === 2) delete filterOptions.sortOrder;
   
    setFilterOptionsGlobal(filterOptions);
    AxiosInstance(PORTS.USER_SERVICE, "application/json")
      .post("admin/userList", filterOptions)
      .then((res) => {
        if (res && res.data && (res.status === "200" || res.status === 200)) {
          setIsLoading(false);
          setCustomerList(res.data.data);
          localStorage.setItem("customerList", JSON.stringify(res.data.data));
          setPagination(res.data.pagination);
        }
      })
      .catch((er) => {
        const data = { type: "error" };
        if (er.response) {
          data.message = "Error";
          data.description = "Failed to get data";

          showNotification(data);
        }
      })
      .finally(() => {
        setIsLoading({ delete: false, list: false });
      });
  }

  function showNotification({ type, message, description }) {
    let options = {
      message: message || "Message",
      description: description,
      duration: 5,
    };
    notification[type](options);
  }

  function closeAll() {
    userList(pageSize, nextPage);
    setSelectedCustomer({});
    setChildComponentVisibility({
      ...childComponentVisibility,
      editProduct: false,
      addProduct: false,
    });
    setSearch("");
  }

  function closeEditProduct() {
    userList(pageSize, nextPage);
    setSelectedCustomer({});
    setChildComponentVisibility({
      ...childComponentVisibility,
      editProduct: false,
      addProduct: true,
    });
    setSearch("");
  }

  function editCustomer(user) {
    setSelectedCustomer(user);
    setChildComponentVisibility({
      ...childComponentVisibility,
      editProduct: true,
      addProduct: false,
    });
    window.scrollTo(0, 0);
    setSearch("");
  }

  if (childComponentVisibility.addProduct) {
    return (
      <AddUser
        handleClose={() =>
          setChildComponentVisibility({
            ...childComponentVisibility,
            addProduct: false,
          })
        }
      />
    );
  } else if (childComponentVisibility.editProduct) {
    return (
      <EditUserComponent
        customer={selectedCustomer}
        handleClose={closeEditProduct}
        closeAll={closeAll}
      />
    );
  }

  function addUserPage(path) {
    history.push(`/site-settings${path}`);
  }

  function handlePaginationChanges(value, type) {
    let updatedFilter = {
      search: search,
      sortOrder: 2,
    };
    if (type === "pageSize") {
      setPageSize(value);
      setNextPage(1);
      userList(value, 1, updatedFilter);
    } else if (type === "nextPage") {
      setNextPage(value);
      userList(pageSize, value, updatedFilter);
    }
  }

  //TO SHOW TABLE HEADERS BASED ON STATUS
  const renderHeader = (props) => {
    return (
      <tr>
        {columns.map((item, idx) => {
          if (item.visible) return props.children[idx];
        })}
      </tr>
    );
  };

  // * TO SHOW TABLE DATA BASED ON HEADER STATUS
  const renderBody = (props) => {
    if (props.children.length > 0) {
      return (
        <tr className={props.className}>
          {columns.map((item, idx) => {
            if (item.visible) {
              return props.children[idx];
            }
          })}
        </tr>
      );
    } else {
      return (
        <tr className="bg-transparent text-info">
          <td colSpan="3">No data found!</td>
        </tr>
      );
    }
  };

  const rearrange = (oldIndex, newIndex) => {
    oldIndex = oldIndex === 0 ? 2 : oldIndex;
    newIndex = newIndex === 0 ? 2 : newIndex;
    if (oldIndex !== 2 && newIndex !== 2) {
      setItems(arrayMove(items, oldIndex, newIndex));
      const itemClone = [...items];
      let values = rearrange_array(itemClone, oldIndex, newIndex);
      fetchNewOrder(values);
    }
  };

  const rearrange_array = (arr, oldIndex, newIndex) => {
    if (newIndex >= arr.length) {
      let i = newIndex - arr.length + 1;
      while (i--) {
        arr.push(undefined);
      }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    return arr;
  };

  const fetchNewOrder = async (items) => {
    let newStatus = [];
    items.map((item, index) => {
      let obj = {};
      obj.order = index;
      obj.status = item.status;
      obj.value = item.value;
      obj._id = item._id;
      newStatus.push(obj);
    });
    setItems(newStatus);
    set_new_header(newStatus);
  };

  const on_field_check_handler = (e, id) => {
    const itemClone = [...items];
    let objIndex = items.findIndex((obj) => obj._id === id);
    itemClone[objIndex].status = e.target.checked ? 1 : id === 2 ? 1 : 0;
    setItems(itemClone);
    fetchNewOrder(items);
  };

  const menu = (
    <Menu className="columns_list">
      <MovableListComponent
        listProps={{
          values: items,
          onChange: ({ oldIndex, newIndex }) => rearrange(oldIndex, newIndex),
          renderList: ({ children, props }) => (
            <ul {...props} style={{ listStyleType: "none" }}>
              {children}
            </ul>
          ),
          renderItem: ({ value, props }) => (
            <li {...props} key={value._id} className="columns_list_item">
              {value.value !== "select" && (
                <>
                  <input
                    type="checkbox"
                    checked={value.status === 1 ? true : false}
                    onChange={(event) =>
                      on_field_check_handler(event, value._id)
                    }
                  />
                  <span class="checkmark" style={{ cursor: "move" }}></span>
                  <span>
                    {value.value
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, function (str) {
                        return str.toUpperCase();
                      })}
                    <img src={dots} alt="image" />
                  </span>
                </>
              )}
            </li>
          ),
        }}
      />
    </Menu>
  );

  // *** DATE RANGE ONCHANGE FUNCTION *** //
  const dateRangeOnchangeHandler = (date, dateString) => {
    const clonefilteredDate = { ...filteredDate };
    clonefilteredDate.startDate = dateString[0]
      ? moment(dateString[0], "DD-MM-YYYY").format("YYYY-MM-DD")
      : "";
    clonefilteredDate.endDate = dateString[1]
      ? moment(dateString[1], "DD-MM-YYYY").format("YYYY-MM-DD")
      : "";
    setFilteredDate(clonefilteredDate);
    let updatedFilter = {
      search: search,
      nextpage: 1,
      regionId: regionId,
      status: statusId,
      sortOrder:sortorder,
      startDate: dateString[0]
        ? moment(dateString[0], "DD-MM-YYYY").format("YYYY-MM-DD")
        : "",
      endDate: dateString[1]
        ? moment(dateString[1], "DD-MM-YYYY").format("YYYY-MM-DD")
        : "",
      filterDays: filterDays,
    };

    debounceSearch(updatedFilter);
  };

  const filterMenu = (
    <Menu className="filter_dropdown">
      <div className="card">
        <div className="card_contents">
          <div className="card_info">Filter by</div>
          <div className="row no-gutters">
            <div className="card_dropdown col-md-6">
              <div className="filter_heading card_dropdown_heading">
                Select Filter <img src={arrowDown} width={10} height={20} />
              </div>
              <div className="card_dropdown_contents">
                {Array.isArray(selectFilter)
                  ? selectFilter.map((filter) => (
                      <span key={filter._id}>
                        <input
                          type="checkbox"
                          checked={filter.isChecked}
                          onChange={(e) => commonFilterHandler(e, filter)}
                        ></input>
                        <label>{filter.name}</label>
                      </span>
                    ))
                  : null}
              </div>
            </div>
            {selectedFilters.length > 0 &&
              selectedFilters.find((x) => x === "region") === "region" && (
                <div className="card_dropdown show col-md-6">
                 
                  <div
                    style={{ width: "100%" }}
                    className="filter_heading card_dropdown_heading"
                  >
                    {regionName}
                    <img alt="" src={arrowDown} width={10} height={20} />
                  </div>
                  <div className="card_dropdown_contents card_slect_hover card_dropdown_no_padding">
                    {Array.isArray(regions)
                      ? regions.map((region) => (
                          <span
                            key={region._id}
                            onClick={() =>
                              filterRegionChange("regionId", region)
                            }
                          >
                            <label>{region.name}</label>
                          </span>
                        ))
                      : null}
                  </div>
                </div>
              )}
            
            {selectedFilters.length > 0 &&
              selectedFilters.find((x) => x === "date") === "date" && (
                <div className="card_dropdown show col-md-6">
                  
                  <div
                    style={{ width: "100%" }}
                    className="filter_heading card_dropdown_heading"
                  >
                    {filterDaysName}
                    <img alt="" src={arrowDown} width={10} height={20} />
                  </div>
                  <div className="card_dropdown_contents card_slect_hover card_dropdown_no_padding">
                    {Array.isArray(filterdayArr)
                      ? filterdayArr.map((day) => (
                          <span
                            key={day._id}
                            onClick={() =>
                              filterRegionChange("filterDays", day)
                            }
                          >
                            <label>{day.name}</label>
                          </span>
                        ))
                      : null}
                  </div>
                </div>
              )}
            {selectedFilters.length > 0 &&
              selectedFilters.find((x) => x === "date") === "date" &&
              filterDays === "custom" && (
                <div className="card_dropdown show col-md-12">
                  <AntDateRangeSelectComponent
                    selectProps={{
                      placeholder: placeholder,
                      onChange: dateRangeOnchangeHandler,
                      name: "sessionDateRange",
                      format: dateFormatList,
                    }}
                  />
                </div>
              )}
          </div>
        </div>
      </div>
    </Menu>
  );


  /**
   * @author Rajkumar
   * @param {event}
   * To get filters of all parent check box
   */
  const commonFilterHandler = (e, data) => {
    const { checked } = e.target;
    let cloneSelectedFilters = [...selectedFilters];
    const cloneSelectFilter = [...selectFilter];
    let updatedFilter = {
      search: search,
      nextpage: 1,
      regionId: regionId,
      status: statusId,
      sortOrder:sortorder,
      filterDays: filterDays,
      startDate: filteredDate.startDate,
      endDate: filteredDate.endDate,
    };
    cloneSelectFilter.forEach((item) => {
      if (item.id === data.id) {
        item.isChecked = checked;
        if (checked) {
          cloneSelectedFilters.push(item.value);
        } else {
          cloneSelectedFilters = cloneSelectedFilters.filter(
            (item) => data.value !== item
          );
        }
      }
      if (!item.isChecked && item.id === data.id) {
        if (item.value === "region") {
          updatedFilter.regionId = "";
          setRegionId("");
          setRegionName("All Region");
        }
        if (item.value === "statusId") {
          updatedFilter.statusId = "";
          setStatusId("");
        }
        if (item.value === "date") {
          updatedFilter.startDate = "";
          updatedFilter.filterDays = "";
          updatedFilter.endDate = "";
          setFilterDays("");
          setFilterDaysName("Date");
        }
        debounceSearch(updatedFilter);
      }
    });
    setSelectedFilters(cloneSelectedFilters);
    setSelectFilter(cloneSelectFilter);
  };

  /**
   * @author Rajkumar
   * @param {event}
   * To get filtered response from region and filterdays changes
   */
  function filterRegionChange(name, value) {
    // const { name, value } = e.target;
    let updatedFilter = {
      search: search,
      nextpage: 1,
      regionId: regionId,
      status: statusId,
      filterDays: filterDays,
      sortOrder:sortorder,
    };
    if (name === "regionId") {
      updatedFilter.regionId = value._id;
      setRegionId(value._id);
      setRegionName(value?.name);
    }
    if (name === "filterDays") {
      updatedFilter.filterDays = value.value;
      setFilterDays(value.value);
      setFilterDaysName(value.name);
    }
    if (value !== "custom") {
      const clonefilteredDate = { ...filteredDate };
      clonefilteredDate.startDate = "";
      clonefilteredDate.endDate = "";
      updatedFilter.startDate = "";
      updatedFilter.endDate = "";
      setFilteredDate(clonefilteredDate);
    }
    debounceSearch(updatedFilter);
  }

  function debounceSearch(filter) {
    setNextPage(1);
    userList(pageSize, 1, filter,true);
  }

/**
   * @author Rajkumar
   * @param {event}
   * To get state of checked and update each records directly woth isChecked parameter
   */
  const parentCheckbox = (e) => {
    localStorage.removeItem("selectedUsers");
    const { checked } = e.target;
    const cloneCustomerList = JSON.parse(localStorage.getItem("customerList"));
    cloneCustomerList.forEach((item) => {
      item.isChecked = checked;
    });
    let cloneSelectedOrder = [];
    if (localStorage.getItem("selectedUsers")) {
      cloneSelectedOrder = JSON.parse(localStorage.getItem("selectedUsers"));
      if (checked) {
        cloneCustomerList.forEach((item) => {
          cloneSelectedOrder.push(item._id);
        });
      } else {
        cloneSelectedOrder = [];
      }
    } else if (checked) {
      cloneCustomerList.forEach((item) => {
        cloneSelectedOrder.push(item._id);
      });
    }
    localStorage.setItem("selectedUsers", JSON.stringify(cloneSelectedOrder));
    localStorage.setItem("customerList", JSON.stringify(cloneCustomerList));
    setCustomerList(cloneCustomerList);
  };


  /**
   * @author Rajkumar
   * @param {event,record}
   * To get state of checked and update each records directly woth isChecked parameter
   */
  const childCheckbox = (e, record) => {
    const { checked } = e.target;
    const cloneCustomerList = JSON.parse(localStorage.getItem("customerList"));
    let cloneSelectedOrder = [];
    cloneCustomerList.forEach((item) => {
      if (record._id === item._id) {
        item.isChecked = checked;
      }
    });
    if (localStorage.getItem("selectedUsers")) {
      cloneSelectedOrder = JSON.parse(localStorage.getItem("selectedUsers"));
      if (checked) {
        cloneSelectedOrder.push(record._id);
      } else {
        cloneSelectedOrder = cloneSelectedOrder.filter(
          (item) => record._id !== item
        );
      }
    } else if (checked) {
      cloneSelectedOrder.push(record._id);
    }
    localStorage.setItem("selectedUsers", JSON.stringify(cloneSelectedOrder));
    localStorage.setItem("customerList", JSON.stringify(cloneCustomerList));
    setCustomerList(cloneCustomerList);
  };

  /**
   * @author Rajkumar
   * @param { sorting  pagination, pagination} value
   // *** BUILD STATUS CLICK HANDLER *** //
   */
  const bulkStatusClickHandler = (data) => {
    const cloneBulkActionFilter = [...bulkActionFilter];
    cloneBulkActionFilter.forEach((item) => {
      if (item._id === data._id) {
        item.isChecked = true;
      } else {
        item.isChecked = false;
      }
    });
    setBulkActionFilter(cloneBulkActionFilter);
  };


  /**
   * @author Rajkumar
   * @param { sorting  pagination, pagination} value
   *   APPLY BULK ACTION BEFORE SUBMITTING
   */
  const applyBulkActionHandler = (item) => {
    if (localStorage.getItem("selectedUsers")) {
      let selectedUsers = JSON.parse(localStorage.getItem("selectedUsers"));
      if (selectedUsers.length > 0) {
        let data = {
          userIds: selectedUsers,
          status: Number(item.value),
        };
        submitBulkAction(data);
      } else {
        showNotification({
          type: "error",
          message: "Error",
          description: "Please select the users below",
        });
      }
    } else {
      showNotification({
        type: "error",
        message: "Error",
        description: "Please select the users below",
      });
    }
  };

  /**
   * @author Rajkumar
   * @param { sorting  pagination, pagination} value
   *   SUBMIT BULK UPDATE ACTION TO ENABLE/DISABLE
   */
  const submitBulkAction = (data) => {
    setIsLoading({ delete: false, list: true });
    AxiosInstance(PORTS.USER_SERVICE, "application/json")
      .post("admin/bulkUpdateStatus ", data)
      .then((res) => {
        if (res && (res.data.status === "200" || res.data.status === 200)) {
          setIsLoading({ delete: false, list: false });
          showNotification({
            type: "success",
            message: "Success",
            description: res.data.msg,
          });
          localStorage.removeItem("selectedUsers");
          const cloneCustomerList = JSON.parse(
            localStorage.getItem("customerList")
          );
          cloneCustomerList.forEach((item) => {
            item.isChecked = false;
          });
          localStorage.setItem(
            "customerList",
            JSON.stringify(cloneCustomerList)
          );
          setCustomerList(cloneCustomerList);
          userList(pageSize, nextPage, "");
        } else if (res.data.status === 400 || res.data.status === "400") {
          showNotification({
            type: "error",
            message: "Error",
            description: res.data.msg,
          });
        }
      })
      .catch((er) => {
        const data = { type: "error" };
        if (er.response) {
          data.message = "Error";
          data.description = "Failed to get data";
          setIsLoading({ delete: false, list: false });
          showNotification(data);
        }
      })
      .finally(() => {
        setIsLoading({ delete: false, list: false });
      });
  };
  // *** BULK ACTION START *** //

  /**
   * @author Rajkumar
   * @param { sorting  pagination, pagination} value
   *   User List sort filter  functionality
   */
  const handleTableChange = (pagination, filters, sorter) => {
    let updatedFilter = {
      search: search,
      nextpage: nextPage,
      regionId: regionId,
      startDate: filteredDate?.startDate,
      endDate: filteredDate?.endDate,
      sortOrder: sorter.order === "descend" ? 1 : 0,
    };
    setSortorder(sorter.order === "descend" ? 1 : 0);
    // setNextPage(1);
    userList(pageSize, nextPage, updatedFilter, true);
  };


    /**
   * @author RAJKUMAR
   * @param {onClick}
   * To toggle between role and user list screen
   */
  const toggleClickHandler = (type) => {
    setToggle(!toggle);
    setPageSize(10);
    setSearch("");
    userList(pageSize, nextPage, "");
  };

  /**
   * @author Mithun Prabhu
   * @param {onClick}
   * To get exported CSV file providing object as payload
   */
  const exportToCSV = async (e) => {
    
    let params = filterOptionsGlobal;
    delete params.nextpage;
    delete params.pagesize;

    AxiosInstance(PORTS.USER_SERVICE, "application/json")
      .post("admin/exportUserList ", params)
      .then((resp) => {
        const response = resp && resp.data;
        if (
          response &&
          (response.status === "200" || response.status === 200)
        ) {
          const data = response.data;
          data?.forEach((item) => {
            if (item["Joined on"]) {
              item["Joined on"] = moment(
                item["Joined on"],
                "DD-MM-YYYY HH:mm:ss"
              ).format("MMM Do YYYY, h:mm:ss A");
            }
          });
          let und_res = data;
          const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
          const fileExtension = ".xlsx";
          const ws = XLSX.utils.json_to_sheet(und_res);
          ws["A1"].v = upperCase(ws["A1"].v);
          ws["A1"].bold = true;
          ws["B1"].v = upperCase(ws["B1"].v);
          ws["C1"].v = upperCase(ws["C1"].v);
          ws["D1"].v = upperCase(ws["D1"].v);
          ws["E1"].v = upperCase(ws["E1"].v);

          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "People");
          /* generate an XLSX file */
          XLSX.writeFile(
            wb,
            `Userlist-${moment(new Date())
              .format("YYYY-MM-DD")
              .split("-")
              .join("")}.xlsx`
          );
          // FileSaver.saveAs(data, "WeeklyPlans" + fileExtension);
        } else if (
          response &&
          (response.status === "400" || response.status === 400)
        ) {
          // return [];
        }
      })
      .catch((err) => {
        return err;
      });
  };

  const exportToPDF = () => {
    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
    }
  };

  /**
   * @author Mithun Prabhu
   * @param {onClick}
   * To give updatedObjects for API call
   */
  function searchClick() {
    let updatedFilter = {
      search: search,
      nextpage: 1,
      regionId: regionId,
sortOrder:sortorder,
      filterDays: filterDays,
    };
    debounceSearch(updatedFilter);
  }

  const handleVisibleChange = (flag) => {
    setVisible(flag);
  };

  function confirmDelete() {
    AxiosInstance(PORTS.USER_SERVICE, "application/json")
      .get(`/admin/user/removeUser/${seletedUseId}`)
      .then((res) => {
        if (res.data.status === 200) {
          console.log("res.data",res.data)
          cancelDelete();
          showNotification({
            type: "success",
            message: "Success",
            description: "User details deleted successfully",
          });
           userList(pageSize, nextPage, "");
        } else if(res.data.status === 400) {
          cancelDelete();
          showNotification({
            type: "error",
            message: "Error",
            description: res.data.msg,
          });
        } else {
          cancelDelete();
          showNotification({
            type: "error",
            message: "Error",
            description: "Failed to delete user",
          });
        }
      })
      .catch((er) => {
        showNotification({
          type: "error",
          message: "Failed",
          description: "Error occured",
        });
      });
  }

  return (
    <div className={commonstyles.management_contents}>
      <SearchComponent />
      <div
        className={`${commonstyles.management_header} ${commonstyles.no_border_bottom} mb-0`}
      >
        <h1 className={commonstyles.management_header_heading}>
          <img
            src={BlackLeftArrow}
            alt=""
            onClick={() => history.push("/site-settings")}
            style={{ cursor: "pointer" }}
          />
          User and permissions
        </h1>
      </div>
      {permissionsArr.length > 0 &&
        permissionsArr.find(
          (x) => x === "SiteSettings-UserandPermission-add"
        ) === "SiteSettings-UserandPermission-add" && (
          <div
            className={`${commonstyles.management_header} ${commonstyles.no_border_bottom} ${commonstyles.outline_left_btn} mb-0`}
          >
            <div className={commonstyles.management_contents_upload}>
              <span
                style={{ cursor: "pointer" }}
                onClick={() =>
                  addUserPage(`${toggle ? "/user/add" : "/role/add"}`)
                }
              >
                {/* <img src={Plus} alt="" /> */}
                Add {toggle ? "User" : "Role"}
              </span>
            </div>
          </div>
        )}

      {toggle &&
        permissionsArr.length > 0 &&
        permissionsArr.find(
          (x) => x === "SiteSettings-UserandPermission-view"
        ) === "SiteSettings-UserandPermission-view" && (
          <div style={{ float: "right" }}>
            <span className={commonstyles.management_header_downloads_text}>
              <Tooltip placement="topRight" title="Download pdf">
                <img
                  className={commonstyles.export_icon}
                  src={pdf_icon}
                  style={{ cursor: "pointer" }}
                  onClick={(e) => exportToPDF(e)}
                />
              </Tooltip>
              <Tooltip placement="topRight" title="Download excel">
                <img
                  src={excelIcon}
                  className={commonstyles.management_header_downloads_icon}
                  alt="icon"
                  style={{ cursor: "pointer" }}
                  onClick={(e) => exportToCSV(e)}
                />
              </Tooltip>
            </span>
            <span className={commonstyles.management_header_downloads_text_ex}>
              Export <img src={exportIcon} alt="icon" />
            </span>
          </div>
        )}
      {permissionsArr.length > 0 &&
        permissionsArr.find(
          (x) => x === "SiteSettings-UserandPermission-view"
        ) === "SiteSettings-UserandPermission-view" && (
          <button
            className={`${commonstyles.sidebarButton} 
          ${toggle && commonstyles.sidebarButton_active} 
            d-inline-block`}
            onClick={() => toggleClickHandler("user")}
          >
            User
          </button>
        )}
      {permissionsArr.length > 0 &&
        permissionsArr.find(
          (x) => x === "SiteSettings-UserandPermission-view"
        ) === "SiteSettings-UserandPermission-view" && (
          <button
            className={`${commonstyles.sidebarButton} 
          ${!toggle && commonstyles.sidebarButton_active} 
            d-inline-block`}
            onClick={() => toggleClickHandler("role")}
          >
            Role
          </button>
        )}
      {toggle
        ? permissionsArr.length > 0 &&
          permissionsArr.find(
            (x) => x === "SiteSettings-UserandPermission-view"
          ) === "SiteSettings-UserandPermission-view" && (
            <>
              <div
                className={`${styles.administrator} ${styles.sitesetting_list_bg}`}
              >
                <div
                  className={`${commonstyles.management_contents_search} ${commonstyles.management_contents_search_sale}`}
                >
                  <div
                    className={`${commonstyles.management_contents_search_bar} input-group`}
                  >
                    <input
                      type="search"
                      className={`${commonstyles.form_control} form-control`}
                      aria-label="Search"
                      placeholder="Search by Name, Email Address..."
                      aria-describedby="search-addon"
                      value={search}
                      onChange={searchHandler}
                    />
                    <img src={Search} alt="" />
                  </div>
                  <ButtonComponent
                    className="theme-btn rnd pl-3 pr-4 ml-2"
                    attributes={{
                      onClick: () => {
                        searchClick();
                      },
                    }}
                  >
                    Search
                  </ButtonComponent>
                  <div className="action ml-3">
                    <div className="action_header">
                      Action
                      <img src={arrowDown} alt="image" />
                    </div>
                    <div className="action_contents">
                      {bulkActionFilter.length > 0 &&
                        bulkActionFilter.map((item) => (
                          <div
                            className="action_contents_header"
                            key={item._id}
                            onClick={() => bulkStatusClickHandler(item)}
                          >
                            <h2
                              className={`action_contents_header_h2 ${
                                item.isChecked &&
                                "action_contents_header_h2_active"
                              }`}
                            >
                              {item.name}
                            </h2>
                            {item.isChecked && (
                              <span
                                className="action_contents_btn"
                                onClick={() => applyBulkActionHandler(item)}
                              >
                                Apply
                              </span>
                            )}
                          </div>
                        ))}
                    </div>
                  </div>
                  <Dropdown
                    overlay={filterMenu}
                    onVisibleChange={handleVisibleChange} visible={visible}
                    className="usermanage_table_filter_columns ml-3"
                  >
                    <div
                      className="ant-dropdown-link"
                      onClick={(e) => e.preventDefault()}
                    >
                      Filter <img src={arrowDown} width={10} height={20} />
                    </div>
                  </Dropdown>
                  <Dropdown
                    overlay={menu}
                    className="usermanage_table_filter_columns ml-3"
                  >
                    <div
                      className="ant-dropdown-link"
                      onClick={(e) => e.preventDefault()}
                    >
                      Columns <img src={arrowDown} width={10} height={20} />
                    </div>
                  </Dropdown>
                </div>
                <div className={styles.administrator_table}>
                  <div className={styles.administrator_table_tabs}></div>

                  <div
                    className={"table-responsive " + styles.management_table}
                  >
                    {!IsLoading?.list && customerList?.length > 0 && (
                      <input
                        type="checkbox"
                        className={`${commonstyles.parentCheckbox}`}
                        onChange={parentCheckbox}
                      ></input>
                    )}
                    {IsLoading?.list === true ? (
                      <div
                        style={{
                          marginLeft: "70vh",
                          marginTop: "10vh",
                        }}
                      >
                        <tr className="bg-transparent">
                          <td colSpan="100%">
                            <LoadingIndicator loadingText="Fetching User details..." />
                          </td>
                        </tr>
                      </div>
                    ) : (
                      <PDFExport
                        ref={pdfExportComponent}
                        paperSize="auto"
                        margin={40}
                        fileName={`UserList for ${new Date().getFullYear()}`}
                        author="Damro Team"
                      >
                        <AntTableComponent
                          className="order_table"
                          tableProps={{
                            columns: columns,
                            dataSource: customerList,
                            pagination: false,
                            onChange: handleTableChange,
                            components: {
                              header: {
                                row: (props) => renderHeader(props),
                              },
                              body: {
                                row: (props) => renderBody(props),
                              },
                            },
                          }}
                        />
                      </PDFExport>
                    )}
                  </div>
                </div>
              </div>
              {Array.isArray(customerList) && customerList.length ? (
                <Pagination
                  pageSizes={pageSizes}
                  pageSize={pageSize}
                  nextPage={nextPage}
                  data={pagination}
                  handlePaginationChanges={handlePaginationChanges}
                />
              ) : null}
            </>
          )
        : permissionsArr.length > 0 &&
          permissionsArr.find(
            (x) => x === "SiteSettings-UserandPermission-edit"
          ) === "SiteSettings-UserandPermission-edit" && <RoleManagement />}

     <ConfirmationBox
        modal={{
          show: isDeleteModule,
          size: "md",
          centered: true,
        }}
        handleCancel={cancelDelete}
        handleConfirm={confirmDelete}
        title="Confirm the action"
        confirmText="Delete"
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-7">
              <span className="theme-txt-subtitle">
              Are you sure want to delete?
              </span>
            </div>
          </div>
        </div>
      </ConfirmationBox>
    </div>
  );
}

export default UserManagement;
